<template>
  <div class="warning-rules-banner" :style="{ padding: padding, gap: bannerStyles.gap , backgroundColor: bannerStyles.backgroundColor, borderColor: bannerStyles.borderColor }">
    <base-icon width="24" height="24" :name="iconName" :style="{ color: bannerStyles.iconColor }" />
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'WarningRulesBanner',
  props: {
    text: {
      type: String,
      required: true
    },
    padding: {
      type: String,
      default: '16px 24px'
    },
    type: {
      type: String,
      default: 'warning',
      validator: value => ['info', 'warning'].includes(value)
    },
    icon: {
      type: String,
      default: null
    }
  },
  computed: {
    iconName() {
      if (this.icon) {
        return this.icon
      }
      return 'painel/filled-info-icon'
    },
    bannerStyles() {
      return this.type === 'info' ? {
        backgroundColor: '#F6F7F9',
        borderColor: '#D4DBE3',
        iconColor: '#5D758D',
        gap: '12px'
      } : {
        backgroundColor: '#FFFFDB',
        borderColor: '#FFDF1B',
        iconColor: '#EEA731',
        gap: '5px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warning-rules-banner {
  width: 100%;
  border: 1px solid;
  border-radius: 8px;

  display: flex;
  align-items: center;

  svg {
    flex-shrink: 0;
  }

  p {
    color: #5D758D;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    text-align: justify;
  }
}
</style>